module.exports = __webpack_public_path__ + "img/66.8.TSS.593f2c81.png";